import React from 'react';
import FlexParent from 'modules/emergencies/components/ui/layout/FlexParent';
import LogReasonsContainer from 'modules/emergencies/components/ui/containers/logReasonsContainer';
import BulletPoint from 'modules/emergencies/components/ui/layout/BulletPoint';

const LogItemNotificationFailedBody = ({ log }) => {
  if (log?.action_object?.type === 'power2_email_outbox_entry')
    return (
      <LogReasonsContainer>
        <FlexParent>
          <BulletPoint />
          Email: {log.action_object.data.email}
        </FlexParent>
      </LogReasonsContainer>
    );
  if (log?.action_object?.type === 'power2_whatsapp_outbox_entry')
    return (
      <LogReasonsContainer>
        <FlexParent>
          <BulletPoint />
          Phone: {log.action_object.data.phone_number}
        </FlexParent>
      </LogReasonsContainer>
    );
  return <></>;
};

export default LogItemNotificationFailedBody;
